import { primeLeadToken, submitLead } from './submit-lead.js';
import { trackEvent } from './analytics.js';

export function connectPlatformVoteForm() {
    const form = document.querySelector('.platform-vote__form');
    if (!form) return;

    let inFlight = false;
    let voted = false;

    primeLeadToken(form, 'site-vote');

    form.addEventListener('submit', (e) => {
        e.preventDefault();

        if (inFlight || voted) return false;

        const checked = form.querySelector('input[name="platform"]:checked');
        if (!checked) return false;

        inFlight = true;
        setButtonState('SENDING…', true);

        submitLead('site-vote', {
            platform: checked.value,
            website: form.elements.website?.value || '',
        }, form)
            .then(() => {
                console.info('[CPB:lead] Platform vote submitted');
                trackEvent('vote_cast', { event_category: 'engagement', platform: checked.value });
                voted = true;
                setButtonState('VOTED', true);
            })
            .catch((err) => {
                console.error('[CPB:lead] Platform vote submit failed', err);
                setButtonState('ERROR — TRY AGAIN', false);
            })
            .finally(() => {
                inFlight = false;
            });

        return false;
    });

    function setButtonState(text, disabled) {
        const button = form.querySelector('button[type="submit"]');
        if (!button) return;
        button.innerText = text;
        if (disabled) button.setAttribute('disabled', true);
        else button.removeAttribute('disabled');
    }
}
